const SENSITIVE_ASSIGNMENT_RE =
  /((?:access[_-]?token|refresh[_-]?token|id[_-]?token|csrf[_-]?token|api[_-]?key|authorization|cookie|password|secret|token)\s*[:=]\s*)[^\s,;]+/gi;
const QUERY_VALUE_RE = /([?&][A-Za-z0-9_.-]+=)[^&#\s]+/g;
const BEARER_RE = /\bBearer\s+[^\s]+/gi;
const JWT_RE = /\beyJ[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}\b/g;
const EMAIL_RE = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/gi;

/** Return bounded runtime text without control characters or common secrets. */
export function redactRuntimeText(value: unknown, max: number, keepNewlines = false): string | undefined {
  if (typeof value !== "string") return undefined;
  let controls: RegExp;
  // CR (0x0D) goes too: a stack trace needs \n and \t, never a bare carriage return, and a
  // viewer rendering the parsed text can be made to overwrite a line with one. Mirrors the
  // authoritative validator in apps/bff/src/routes/diagnostics/schema.ts.
  // eslint-disable-next-line no-control-regex
  if (keepNewlines) controls = /[\u0000-\u0008\u000B-\u001F\u007F-\u009F]/g;
  // eslint-disable-next-line no-control-regex
  else controls = /[\u0000-\u001F\u007F-\u009F]/g;
  return value
    .replace(controls, "")
    .replace(SENSITIVE_ASSIGNMENT_RE, "$1[REDACTED]")
    .replace(QUERY_VALUE_RE, "$1[REDACTED]")
    .replace(BEARER_RE, "Bearer [REDACTED]")
    .replace(JWT_RE, "[REDACTED]")
    .replace(EMAIL_RE, "[REDACTED]")
    .slice(0, max);
}
